import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import PageBreadcrumb from '../components/PageBreadcrumb';
import { RefreshIcon } from '../components/Icons';
import { getHealth } from '../services/healthService';
import '../components/DataPage.css';
import './Health.css';

function Health() {
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState(null);

  const loadHealth = useCallback(async () => {
    setLoading(true);

    try {
      const data = await getHealth();
      setResult(data);
    } catch (err) {
      setResult(null);
      toast.error(err.message || 'Failed to load health status');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadHealth();
  }, [loadHealth]);

  const jsonText = result
    ? JSON.stringify(result.body, null, 2)
    : loading
      ? 'Loading…'
      : 'No response yet.';

  const statusLabel =
    result?.httpStatus > 0
      ? ` · HTTP ${result.httpStatus}`
      : result && result.httpStatus === 0
        ? ' · unreachable'
        : '';

  return (
    <div className="data-page health-page">
      <PageBreadcrumb current="System Health" />

      <section className="data-page__header">
        <div className="data-page__intro">
          <h2>System Health</h2>
          <p className="data-page__subtitle">
            Server status
            {statusLabel}
          </p>
        </div>

        <button
          type="button"
          className="data-page__import-btn"
          onClick={loadHealth}
          disabled={loading}
        >
          <RefreshIcon />
          {loading ? 'Checking…' : 'Refresh'}
        </button>
      </section>

      <pre
        className={`health-page__json${
          result && !result.ok ? ' health-page__json--error' : ''
        }`}
        aria-live="polite"
      >
        {jsonText}
      </pre>
    </div>
  );
}

export default Health;
